<template>
  <div class="row" v-if="showMessage">
    <div class="col">
      <h2>Mural de recados</h2>
      <simplert :useRadius="true"
                :useIcon="true"
                ref="simplert">
      </simplert>

      <div id="mural">
        <vue-scrollbar v-if="messages.length > 0" classes="my-scrollbar" ref="Scrollbar">
          <div class="scroll-me content">
            <div v-for="item in messages" class="comentario">
              <div class="avatar">{{ item.avatar }}</div>
              <span>{{ item.name }}</span>
              <p>{{ item.comment }}</p>
              <div v-if="item.answers" class="resposta">
                <div class="avatar"><i class="fas fa-user"></i>
                </div>
                <span>{{ item.answers.name }}</span>
                <p> {{ item.answers.comment }} </p>
              </div>
            </div>
          </div>
        </vue-scrollbar>

        <div v-if="!messages.length">
          <div class="mural-sem-recado">
            <i v-if="!getStatus" class="fas fa-share"></i>
            <img src="static/images/pessoas.svg" alt="Mural de recados">
            <h4>Deixe o seu recado</h4>
            <p>Aproveite este espaço e envie sua mensagem para nossa rádio. Participe! Para deixar seu recado, é
              necessário entrar com sua conta do Facebook.</p>
          </div>
          <!--<fb-signin-button v-if="!getStatus"-->
          <!--:params="fbSignInParams"-->
          <!--@success="onSignInSuccess"-->
          <!--@error="onSignInError">-->
          <!--Entrar com conta do Facebook-->
          <!--</fb-signin-button>-->
        </div>
        <form v-show="!msgSend">
          <input v-model="name" type="text" placeholder="Seu nome">
          <textarea v-model="comment" placeholder="Deixe seu recado"></textarea>

          <vue-recaptcha ref="recaptcha"  @verify="onVerify" @expired="onExpired" :sitekey="sitekey" class="captcha">
          </vue-recaptcha>

          <button type="button" @click="sendComment()"> Enviar</button>
          <div id="status"></div>
        </form>
      </div>

    </div>
    <div class="voto-sucesso" v-if="msgSend">
      <p><i class="fas fa-check"></i> Mensagem enviada com sucesso! </p>
    </div>
  </div>
</template>
<script>
  import FBSignInButton from 'vue-facebook-signin-button'
  import services from '../service/api'
  import Simplert from 'vue2-simplert'
  import VueScrollbar from 'vue2-scrollbar'
  import VueRecaptcha from 'vue-recaptcha';

  export default {
    props: [],
    name: "Message",
    components: {
      FBSignInButton,
      VueScrollbar,
      Simplert,
      VueRecaptcha
    },
    data() {
      return {
        fbSignInParams: {
          scope: 'email,user_likes',
          return_scopes: true
        },
        user: {},
        userStatus: null,
        messages: {},
        showMessage: window.config.site.message,
        comment: '',
        name: '',
        msgSend: false,
        sitekey: window.config.RECAPTCHA_KEY,
        captcha:false
      }
    },
    computed: {
      // analisar se esta conectado com o face ou não, se não estiver exibir botao de login
      getStatus() {
        let self = this;
        if (self.userStatus == "connected") {
          return true;
        }
        return false;
      }
    },
    created() {
      let self = this;
      if (self.showMessage) {
        // ao inicar o component, registrar lib do facebook para um possivel login, tambem verifica o status, se esta conectado ou nao
        services.post('messages').then(function (response) {
          self.messages = response.data;
          self.showMessages = true;
        });
      //   // ao inicar o component, registrar lib do facebook para um possivel login, tambem verifica o status, se esta conectado ou nao
      //   //http://graph.facebook.com/1945485112189343/picture?type=large
      //   window.fbAsyncInit = function () {
      //     FB.init({
      //       appId: '1757136444545084',
      //       cookie: true,  // enable cookies to allow the server to access the session
      //       xfbml: true,  // parse social plugins on this page
      //       version: 'v2.8' // use graph api version 2.8
      //     });
      //     FB.getLoginStatus(function (response) {
      //       self.userStatus = response.status;
      //       // console.log(response)
      //     });
      //   };
      //   (function (d, s, id) {
      //     var js, fjs = d.getElementsByTagName(s)[0];
      //     if (d.getElementById(id)) return;
      //     js = d.createElement(s);
      //     js.id = id;
      //     js.src = "//connect.facebook.net/en_US/sdk.js";
      //     fjs.parentNode.insertBefore(js, fjs);
      //   }(document, 'script', 'facebook-jssdk'));
      }
    },
    mounted() {
      // console.log('estou inicnando')
    },
    methods: {
      onSubmit: function () {
        this.$refs.recaptcha.execute();
      },
      onVerify: function (response) {
        this.captcha = response;
      },
      onExpired: function () {
        console.log('Expired')
      },
      resetRecaptcha () {
        this.$refs.recaptcha.reset() // Direct call reset method
      },
      onSignInSuccess(response) {
        let self = this;
        FB.api('/me', dude => {
          this.user = dude
          self.userStatus = "connected";
        })
      },
      onSignInError(error) {
        console.log('OH NOES', error)
      },
      sendComment() {
        let self = this;
        if (!self.name) {
          alert('campo nome é obrigatório')
          return false
        }
        if (!self.comment) {
          alert('campo mensagem é obrigatório')
          return false
        }
        if(!this.captcha){
          alert("captcha obrigatória");
          return false;
        }

        let data = {
          'mensagem': self.comment,
          // 'id_user': response.id,
          'name': self.name,
          // 'image': "http://graph.facebook.com/" + self.user.id + "/picture?type=large"
        };
        services.sendMessage(data).then(function (resp) {
          // console.log( resp)
          self.msgSend = true;
          self.name = '';
          self.comment = '';
          self.msgSend = true;
          self.resetRecaptcha();
          alert('Mensagem enviada com sucesso');
          setTimeout(function () {
            self.msgSend = false;
          }, 3000);
        });


        // FB.api('/me', function (response) {
        //   // console.log('Successful login for: ' + response.name);
        //   self.user.name = response.name;
        //   self.user.id = response.id;
        //   let data = {
        //     'mensagem': self.comment,
        //     // 'id_user': response.id,
        //     'name': self.name,
        //     // 'image': "http://graph.facebook.com/" + self.user.id + "/picture?type=large"
        //   };
        //   services.sendMessage(data).then(function (resp) {
        //     // console.log( resp)
        //     self.comment = '';
        //     self.msgSend = true;
        //     setTimeout(function () {
        //       self.msgSend = false;
        //     }, 3000);
        //   });
        // });
      }
    }
  }
</script>

<style scoped>
  .fb-signin-button {
    /* This is where you control how the button looks. Be creative! */
    display: inline-block;
    padding: 4px 8px;
    border-radius: 3px;
    background-color: #4267b2;
    color: #fff;
  }

  .my-scrollbar {
    min-width: 200px;
    max-height: 300px;
  }

  /*The Content*/
  .scroll-me {
    min-width: 200px;

  }

  .scrollbar {
    border-radius: 10px;
    min-height: 50px;
    cursor: pointer;
    background: rgba(0, 0, 0, 1) !important;
  }

  .my-scrollbar[data-v-f28e9bfe] {
    background: none;
  }

  .vue-scrollbar__scrollbar-vertical {
    background: #0a6aa1;
  }
</style>


// WEBPACK FOOTER //
// src/components/Message.vue